// extracted by mini-css-extract-plugin
module.exports = {"item":"faq_item__5y_Ng","question":"faq_question__0ibOx","icon":"faq_icon__I4kNn","rotate":"faq_rotate__16Gjb","answer":"faq_answer__Eb6G2","slideDown":"faq_slideDown__dJAdr"};